module.exports = __webpack_public_path__ + "media/images/flags/1x1/lbn-084c3df9705c1dc686f85f65fe5da4ff.svg";